import { Component } from '@angular/core';
import { AuthService } from './auth';

@Component({
  selector: 'app-user-not-authorized',
  templateUrl: './user-not-authorized.component.html',
  styleUrl: './user-not-authorized.component.css',
  standalone: false,
})
export class UserNotAuthorizedComponent {

  constructor(private authService: AuthService) { }

  ngOnInit() {
  }

  logout() {
    this.authService.signOut().subscribe();
  }
}
